<template>
  <div>
    <Field
      :label="$t('inputType')"
      :options="inputTypeOptions"
      type="select"
      :value.sync="inputTypeSelected" />
    <Field
      :disabled="!inputTypeSelected"
      :label="$t('items')"
      required
      type="textarea"
      :value.sync="urlLines" />
    <Field
      :label="$t('run')"
      type="checkbox"
      :value="!pageBatch.isPaused"
      @update:value="pageBatch.isPaused = !$event" />
  </div>
</template>

<script>
import Message from '@mixins/Message'
import { getters } from '@utils'

export default {
  mixins: [Message],
  props: {
    pageBatch: Object,
  },
  data() {
    return {
      inputTypeOptions: [
        {
          label: 'Raw URLs',
          value: 'raw',
        },
        {
          label: 'Amazon IDs',
          value: 'asin',
        },
      ],
      inputTypeSelected: 'asin',
      urlLines: '',
    }
  },
  computed: {
    urlsArray() {
      const items = this.urlLines.split('\n')

      return this.inputTypeSelected === 'raw'
        ? items
        : items.map(this.formAmazonLink)
    },
    ...getters('formAmazonLink'),
  },
  watch: {
    urlsArray: {
      deep: true,
      handler(urlsArray) {
        this.pageBatch.urls = urlsArray
        this.pageBatch.pageCount = urlsArray.length
      },
    },
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "inputType": "Input type",
    "items": "Items",
    "run": "Run immediately"
  }
}
</i18n>
